<p>product-concept-inline-search-card works!</p>
